import { render } from "./ResourceLibrary.vue?vue&type=template&id=c2e2c640&scoped=true"
import script from "./ResourceLibrary.vue?vue&type=script&lang=js"
export * from "./ResourceLibrary.vue?vue&type=script&lang=js"

import "./ResourceLibrary.vue?vue&type=style&index=0&id=c2e2c640&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e2c640"]])

export default __exports__